import { render, staticRenderFns } from "./addPromo.vue?vue&type=template&id=7ccff913"
import script from "./addPromo.vue?vue&type=script&lang=js"
export * from "./addPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports